exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!style"), undefined);

// module
exports.push([module.id, ".FieldToGroupBy__fieldToGroupByText___190pI {\n  font-size: 14px;\n  color: #949aab;\n}\n", ""]);

// exports
exports.locals = {
	"fieldToGroupByText": "FieldToGroupBy__fieldToGroupByText___190pI " + require("-!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!style").locals["flex-full"] + ""
};